import { SendTestMessageController } from './send-test-message.controller';
import { SendTestMessageSection } from './send-test-message-section.component';

import { SendTestMessageControllerProps } from './use-send-test-message-controller.hook';

export const SendTestMessageSectionController = (props: SendTestMessageControllerProps) => {
  return (
    <SendTestMessageController {...props}>
      {(params) => {
        const {
          membershipUuid,
          onMembershipUuidChange,
          canSendTestSms,
          canSendTestPush,
          sendTestMessage,
        } = params;
        return (
          <SendTestMessageSection
            membershipUuid={membershipUuid}
            onMembershipUuidChange={onMembershipUuidChange}
            canSendSms={canSendTestSms}
            canSendPush={canSendTestPush}
            onSendClick={sendTestMessage}
          />
        );
      }}
    </SendTestMessageController>
  );
};
